import React from 'react';
import styled from 'styled-components';

import BoundModal from './boundModal';
import {pxToEm} from './globalStyles';

export const StyledModalImage = styled.img`
  background: white;
  max-width: 100%;
  max-height: 100%;
  border-radius: ${pxToEm(4)}em;
  padding: ${pxToEm(16)}em;
`;

interface Props {
  boundComponent: React.ReactNode;
  source: string;
  className?: string;
}

const BoundImageModal: React.FunctionComponent<Props> = ({boundComponent, className, source}) => {
  return (
    <div className={className}>
      <BoundModal boundComponent={boundComponent}>
        <StyledModalImage src={source} />
      </BoundModal>
    </div>
  );
};

export default BoundImageModal;
